import { ChatBubbleIcon, Cross2Icon } from '@radix-ui/react-icons';
import { Button, Dialog } from '@radix-ui/themes';
import { useNavigate } from 'react-router-dom';
import { isLoggedIn } from 'helpers/authentication';
import { pushEvent } from 'helpers/crmUtils';
import Analytics from 'ui/design-base/Analytics';
import MessageBox from './MessageBox';

export const MessageDialog: React.FC<{ name: string; id: number; thumbnail: string; recipient_type: string }> = ({
  name,
  id,
  thumbnail,
  recipient_type,
}) => {
  const navigate = useNavigate();

  const onMessageClickFunction = () => {
    Analytics.sendEvent({
      category: 'Profile Interaction',
      action: 'Show Message Modal',
      label: 'Player Header',
    });
    pushEvent('TT - EVENT - message modal opened');
    if (!isLoggedIn()) {
      navigate('/accedi');
    }
  };

  return (
    <Dialog.Root>
      <Dialog.Trigger>
        <Button variant='outline' className='min-w-32 hover:cursor-pointer' onClick={onMessageClickFunction}>
          <ChatBubbleIcon />
          Messaggio
        </Button>
      </Dialog.Trigger>
      <Dialog.Content maxWidth='450px'>
        <div className='flex w-full justify-between align-middle'>
          <Dialog.Title>Invia un messaggio</Dialog.Title>
          <Dialog.Close className='mb-4 cursor-pointer'>
            <Cross2Icon height={'24'} width={'24'} />
          </Dialog.Close>
        </div>
        <Dialog.Description className='hidden'>Scrivi al giocatore - contattalo tramite il form</Dialog.Description>

        <div className='flex flex-1 flex-row flex-wrap'>
          <MessageBox name={name!} thumbnail={thumbnail!} recipient={{ id: id!, type: recipient_type }} />
        </div>
      </Dialog.Content>
    </Dialog.Root>
  );
};
export default MessageDialog;
